
import styles from "./SearchCrawlerKickedOffJobs.module.css";
import { Button, Spinner, Modal} from "react-bootstrap";
import { useEffect, useState, useCallback, useRef } from "react";
import AGTable from "../../../../components/AGTable/AGTable";
import TimedAlert from "../../../../components/TimedAlert/TimedAlert";
import { Link } from "react-router-dom";
import { getSearchCrawlKickedOffJobs, updateSearchCrawlSchedule } from "../../../../api/portalApi";
import HorizontalNavbar from "../../../../components/HorizontalNavbar/HorizontalNavbar";
import SearchCrawlerSchedulerAddSchedule from "../SearchCrawlerScheduler/SearchCrawlerSchedulerAddSchedule/SearchCrawlerSchedulerAddSchedule";

const SearchCrawlerKickedOffJobs = (props) => {
    // Data State
    const [jobs, setJobs] = useState();
    const [error, setError] = useState();
    const [alert, setAlert] = useState();
    const [selectedJob, setSelectedJob] = useState();
    const [activeKey, setActiveKey] = useState('viewJobs');
    const [scheduleObj, setScheduleObj] = useState({
        dayOfWeek: [{value: "Every day", label: "Every day"}],
        day: [{value: "Every day", label: "Every day"}],
        hour: "00:00",
        minute: "00",
    });
    const gridRef = useRef();
    
    // UI State
    const [showAlert, setShowAlert] = useState(false);
    const [showJobModal, setShowJobModal] = useState(false);
    const [loading, setLoading] = useState(false);
    
    const userEmail = props.userEmail;
    
    const menuItems = [
        { key: 'viewJobs', label: 'View Jobs'},
        { key: 'addSchedule', label: 'Add Schedule'},
    ];

    useEffect(() => {
        setScheduleObj({
            dayOfWeek: [{value: "Every day", label: "Every day"}],
            day: [{value: "Every day", label: "Every day"}],
            hour: "00:00",
            minute: "00",
        });
    }, [selectedJob]);

    useEffect(() => {
        if (!showAlert){
            setError();
        }
    }, [showAlert])

    const handleSelectedJob = (job) => {
        setSelectedJob(job);
        setShowJobModal(true);
    };

    const fetchJobs = useCallback(async() => {
        setLoading(true);
        try{
            const res = await getSearchCrawlKickedOffJobs();
            const data = res?.data?.data || res?.data
            setJobs(data?.map((job) => {
                return {
                    ...job,
                    jobs: JSON.stringify(job?.jobs),
                    view_jobs: <Button variant="success" size="sm" onClick={() => handleSelectedJob(job)}>View Jobs</Button>
                }
            }));
        } catch (e){
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(()=> {
        fetchJobs();
    }, [fetchJobs]);

    const addSchedule = async() => {
        setLoading(true);
        try{
            const postData ={
                time: `${scheduleObj?.hour.split(":")[0]}:${scheduleObj?.minute}`,
                day_of_week: scheduleObj?.dayOfWeek.map((day) => day.value === "Every day" ? null : day?.value.slice(0,3)).join(","),
                day: scheduleObj?.day.map((day) => day.value === "Every day" ? null : day?.value).join(","),
                schedule_id: null,
                payload: selectedJob?.jobs?.map((job) => {
                    return {
                        vertical: job?.vertical,
                        match_source: job?.match_source,
                        department: job?.department,
                        search_banner: job?.search_banner,
                        result_banner: job?.result_banner,
                        search_brands: job?.search_brands,
                        result_brands: job?.result_brands,
                        sku_name_similarity_min: job?.sku_name_similarity_min,
                        brand_similarity_min: job?.brand_similarity_min,
                        max_results: job?.max_results,
                        client: job?.client,
                        data_source: job?.data_source,
                        tag: job?.tag,
                        created_by: job?.created_by
                    }
                })
            };
            await updateSearchCrawlSchedule(postData);
            
        } catch (e){
            setError(e);
            setAlert(e?.response?.data?.message);
            setShowAlert(true);
        } finally {
            setLoading(false);
            setShowJobModal(false);
        }
        
    };
    return (
        
        <div>
            <Modal show={showJobModal} size="xl">
                <Modal.Header closeButton onClick={() => setShowJobModal(false)}>
                    <Modal.Title>View Search Crawl Jobs {selectedJob?.tag ? 'for ' + selectedJob?.tag : ''}</Modal.Title>
                </Modal.Header>
                <HorizontalNavbar menuItems={menuItems} activeKey={activeKey} setActiveKey={setActiveKey}/>
                <Modal.Body>
                    { activeKey === 'viewJobs' &&
                        <div>

                            <div style={{display: 'grid'}}>
                                <AGTable data={selectedJob?.jobs?.map((job) => {
                                    return {
                                        ...job,
                                        'job_id': <Link 
                                        to="/search-crawler/match-review"
                                        state={{locationJobid: job?.job_id, userEmail: userEmail}}
                                        >
                                            {job?.job_id}
                                        </Link>
                                    }
                                })}
                                columnsToHide={['tag','parent_sc_id', 'sc_id', 'data_source', 'client', 'vertical', 'match_source', 'match_type', 'sku_name_similarity_min', 'brand_similarity_min', 'max_results', 'spider_key', 'spider_name', 'created_at', 'created_by']}
                                editableFields={[...new Set(selectedJob?.jobs.flatMap(obj => Object.keys(obj)))]}
                                />
                            </div>
                        </div>
                    }
                    { activeKey === 'addSchedule' &&
                        <div>
                            <SearchCrawlerSchedulerAddSchedule scheduleObj={scheduleObj} setScheduleObj={setScheduleObj}/>
                            <div style={{display: 'grid'}}>
                                <AGTable data={selectedJob?.jobs}
                                gridRef={gridRef}
                                columnsToHide={['tag','parent_sc_id', 'sc_id', 'data_source', 'client', 'vertical', 'match_type', 'status', 'spider_key', 'spider_name', 'created_at', 'created_by', 'input_file', 'job_id']}
                                editableFields={[...new Set(selectedJob?.jobs.flatMap(obj => Object.keys(obj)))]}
                                // key={selectedJob?.jobs}
                                />
                            </div>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    {
                        activeKey === 'addSchedule' && 
                            <Button variant="success" onClick={addSchedule}>
                                Add Schedule
                            </Button>
                    }
                    <Button variant="secondary" onClick={() => setShowJobModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <TimedAlert
                message={alert}
                duration={2000}
                variant={error ? "danger" : "success"}
                show={showAlert}
                onClose={() => setShowAlert(false)}
            />
            {!loading && <div className={styles.SearchCrawlerKickedOffJobs}>
                <h4>Search Crawler Kicked Off Jobs</h4>
                {jobs && <AGTable data={jobs} columnsToHide={["jobs"]}/>}
            </div>}
            {loading && <div className={styles.spinnerContainer}>
                <Spinner/>
            </div>}
        </div>

    )
};

export default SearchCrawlerKickedOffJobs;